import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const refresh = () => api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});

  useEffect(() => { refresh(); }, []);

  return (
    <SiteContext.Provider value={{ settings, refresh }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
